import { PrivacyControls } from "@/components/legal/CookieConsent";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/cn";
import { useTranslation } from "react-i18next";
import { useBranding } from "@/lib/branding";

// =============================================================================
// AppFooter — pied de page de l'espace connecté (OBS-15).
// -----------------------------------------------------------------------------
// Rend visibles, partout dans l'application, les liens légaux usuels :
// protection des données, mentions légales, réclamation client, copyright.
// La ligne de copyright suit le co-branding tenant (token `footerLegal`).
// =============================================================================

const LINKS: Array<{ to: string; labelKey: string }> = [
  { to: "/cgu", labelKey: "footer.terms" },
  { to: "/confidentialite", labelKey: "footer.dataProtection" },
  { to: "/mentions-legales", labelKey: "footer.legalNotice" },
  { to: "/reclamation", labelKey: "footer.complaint" },
];

export function AppFooter() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const hasJourneyActions = pathname.endsWith("/parcours") || pathname.endsWith("/dossier/wizard");
  const { tokens } = useBranding();
  const legal =
    tokens.footerLegal && !tokens.footerLegal.includes("75717 Paris Cedex 15")
      ? tokens.footerLegal
      : t("footer.legal");

  return (
    <footer
      className={cn(
        "border-t border-line bg-bg px-4 pt-6 lg:px-8",
        hasJourneyActions ? "pb-48" : "pb-24",
      )}
    >
      <div className="flex flex-col gap-3 text-xs text-ink-subtle md:flex-row md:items-center md:justify-between">
        <nav className="flex flex-wrap items-center gap-x-4 gap-y-2">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="hover:text-ink">
              {t(l.labelKey)}
            </Link>
          ))}
        </nav>
        <PrivacyControls />
        <p className="max-w-xl md:text-right">{legal}</p>
      </div>
    </footer>
  );
}
